import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
export interface Premios{
  auth_key:string,
  data:[{
    id:number,
    id_user:number,
    titulo:string,
    fechaini:number,
    fechafin:number
  }]
}

@Injectable({
  providedIn: 'root'
})
export class PremiosService {

  constructor(private http: HttpClient) { }

  get(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    return this.http.post<Premios>(environment.urlPremios+'?opcion=1', JSON.stringify(postData));
    /********************** */
  }
  create(id,auth_key,data){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    postData.push({'data':data});
    return this.http.post<Premios>(environment.urlPremios+'?opcion=2', JSON.stringify(postData));
    /********************** */
  }
  delete(id,auth_key,data){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    postData.push({'data':data});
    return this.http.post<Premios>(environment.urlPremios+'?opcion=3', JSON.stringify(postData));
    /********************** */
  }
}
